import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { QuillModule } from 'ngx-quill';

import { AppSharedModule } from '../../app-shared.module';
import { DashboardComponent } from './dashboard.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { NotificationsDialogComponent } from './notifications/notifications-dialog/notifications-dialog.component';
import { NotificationsToggleComponent } from './notifications/notifications-toggle/notifications-toggle.component';
import { AssignmentsModule } from '../assignments/assignments.module';
import { BannerComponent } from './banner/banner.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResourcesComponent } from './resources/resources.component';
import { CdkDrag, CdkDropList } from '@angular/cdk/drag-drop';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SpinnerModule } from '../spinner/spinner.module';
import { ListComponent } from './list/list.component';
import { CachedHttpService } from '../../shared/services/cached-http.service';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [
        DashboardComponent,
        NotificationsDialogComponent,
        NotificationsToggleComponent,
        BannerComponent,
        ResourcesComponent,
        ListComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        AppSharedModule,
        AssignmentsModule,
        DashboardRoutingModule,
        QuillModule.forRoot(),
        ReactiveFormsModule,
        CdkDropList,
        CdkDrag,
        TooltipModule,
        SpinnerModule,
        RouterModule,
    ],
    providers: [CachedHttpService],
    exports: [
        NotificationsDialogComponent,
        NotificationsToggleComponent,
        BannerComponent,
        ResourcesComponent,
        ListComponent,
    ],
})
export class DashboardModule {}
